import { render, staticRenderFns } from "./confirmArrivalDialog.vue?vue&type=template&id=3f779aae&"
import script from "./confirmArrivalDialog.vue?vue&type=script&lang=js&"
export * from "./confirmArrivalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports